<template>
    <div>
        <app-bar :title="athlete.name"/>

        <v-layout>
            <v-progress-linear
                v-if="overlay"
                absolute
                indeterminate
            ></v-progress-linear>

            <div class="pt-8 pb-12 px-8">
                <div class="pb-10">
                    <v-btn
                        v-if="permitted('admin_club_management')"
                        @click="edit"
                        class="sm mr-5"
                        color="primary"
                    >{{ t('general_action_edit') }}
                    </v-btn>
                    <confirm-modal
                        v-if="permitted('admin_club_management')"
                        :title="t('general_title_confirm_action')"
                        @agree="del(athlete)"
                    >
                        <template #default="{ on, attrs }">
                            <v-btn
                                class="sm"
                                color="orange"
                                outlined
                                v-on="on"
                                v-bind="attrs"
                            >{{ t('general_action_delete') }}</v-btn>
                        </template>
                    </confirm-modal>
                </div>
                <div class="float-left mr-10" style="width: 200px; max-width: 200px">
                    <img
                        v-if="athlete.photoUrl"
                        :src="athlete.photoUrl"
                        width="200"
                    />
                </div>
                <div class="float-left" style="max-width: calc(100% - 240px)">
                    <card-unit :items="items()">
                        <template #title>{{ t('club_athlete_label_id') }}: {{ athlete.id }}</template>
                    </card-unit>
                </div>
            </div>
        </v-layout>
    </div>
</template>

<script lang="ts">
    import { computed, defineComponent, onMounted, reactive, toRefs } from '@vue/composition-api'
    import { useI18n } from 'vue-i18n-composable'
    import { useStore } from '@/store'
    import { useRouter } from '@/composition-api'
    import { useEnums } from '@/core/defaults'
    import { ClubAthlete } from '@/core/models/club-athlete'
    import ConfirmModal from '@/components/ConfirmModal.vue'
    import CardUnit from '@/components/CardUnit.vue'

    export default defineComponent({
        components: {
            ConfirmModal,
            CardUnit
        },

        setup(props) {
            const store = useStore()
            const router = useRouter()
            const i18n = useI18n()
            const enums = useEnums()
            const id = router.currentRoute.params['id']

            const state = reactive({
                overlay: true,
            })

            const capture = () => {
                store.dispatch('clubAthlete/get', { id: id, payload: {} }).then(() => {
                    state.overlay = false
                })
            }

            const athleteModel = computed(() => <ClubAthlete>store.getters['clubAthlete/get'])

            const edit = () => router.push({ name: 'club-athletes.show', params: { id: <any>athleteModel.value.id } })

            const del = (item: ClubAthlete) => {
                state.overlay = true
                store.dispatch('clubAthlete/delete', { id: item.id }).then(() => {
                    router.push({ name: 'club-athletes' })
                })
            }

            const items = () => {
                return [
                    { text: i18n.t('club_athlete_label_title'), value: athleteModel.value.title || '-' },
                    { text: i18n.t('club_athlete_label_gold_count'), value: athleteModel.value.goldCount },
                    { text: i18n.t('club_athlete_label_silver_count'), value: athleteModel.value.silverCount },
                    { text: i18n.t('club_athlete_label_bronze_count'), value: athleteModel.value.bronzeCount },
                    { text: i18n.t('club_athlete_label_status'), value: enums.clubAthleteStatusTitle(athleteModel.value.status) },
                    { text: i18n.t('general_label_creation_date'), value: athleteModel.value.createdAt.format('DD/MM/YYYY') },
                ]
            }

            onMounted(() => {
                capture()
            })

            return {
                capture,
                items,
                athlete: athleteModel.value,
                edit,
                del,
                ...useI18n(),
                ...useEnums(),
                ...toRefs(state)
            }
        }
    })
</script>
